import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import WordleGame from "./WordleGame";
import LeaderboardPage from "./LeaderboardPage";
import StartScreen from "./StartScreen";
import ConnectProGame from "./ConnectProGame";
import HowToPlayPage from "./HowToPlayPage";

const installHubAuthFetch = () => {
  if (typeof window === 'undefined' || window.__hubAuthFetchInstalled) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const token = new URLSearchParams(window.location.search).get('hub_token') || localStorage.getItem('hubToken') || '';
    if (token) localStorage.setItem('hubToken', token);
    const headers = new Headers(init.headers || {});
    if (token) headers.set('X-Hub-Token', token);
    return originalFetch(input, { ...init, headers });
  };
  window.__hubAuthFetchInstalled = true;
};

installHubAuthFetch()

const LOGIN_URL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'http://localhost:3000' : "https://games.precisionpros.com";
const PLAYABLE_ROUTES = new Set(["/", "/play", "/game", "/connectpro"]);

const shouldRedirectToUnifiedLogin = () => {
  if (typeof window === "undefined") return false;

  const { hostname, pathname, search } = window.location;
  const params = new URLSearchParams(search);
  const hasHubToken = params.get("hub_token") || localStorage.getItem("hubToken");
  const isLocalDev = hostname === "localhost" || hostname === "127.0.0.1";

  return !hasHubToken && PLAYABLE_ROUTES.has(pathname);
};

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const playerName = params.get('player_name');
    if (playerName) {
      localStorage.setItem('playerName', playerName);
    }
  }, []);

  useEffect(() => {
    if (shouldRedirectToUnifiedLogin()) {
      window.location.replace(LOGIN_URL);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ConnectProGame />} />
        <Route path="/play" element={<StartScreen />} />
        <Route path="/game" element={<WordleGameWrapper />} />
        <Route path="/connectpro" element={<ConnectProGame />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/how-to-play" element={<HowToPlayPage />} />
      </Routes>
    </BrowserRouter>
  );
}


function WordleGameWrapper() {
  const location = useLocation();
  const { playerName, gameMode } = location.state || { playerName: "", gameMode: "medium" };

  return <WordleGame playerName={playerName} gameMode={gameMode} />;
}

export default App;
